export const SET_SPECIAL_OFFER_DETAIL_ACTION =
	"SET_SPECIAL_OFFER_DETAIL_ACTION";

export const SET_GIFT_EXCHANGE_DETAIL_ACTION =
	"SET_GIFT_EXCHANGE_DETAIL_ACTION";

export const SET_PROMOTION_DETAIL_ACTION = "SET_PROMOTION_DETAIL_ACTION";
